import React from "react";
import { withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  requestRemoveCompanyListing,
  setDisplayIndex,
} from "../../../../../../redux/actions/single-list";
import { InfoTableButton } from "../../../../../library/button";
import "./style.scss";

const Index = ({ singleCompany, match, displayIndex, arr }) => {
  const dispatch = useDispatch();

  const listId = match.params.id;
  const responses = useSelector((state) => state.singleList.responses);
  const activeDisplay = useSelector((state) => state.singleList.activeDisplay);
  //const addResponseLoading = useSelector(state => state.singleList.addResponseLoading)
  //const fetchResponsesLoading = useSelector(state => state.singleList.fetchResponsesLoading)
  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );

  const activeRemoval = useSelector(
    (state) => state.singleList.removeSingleCompany.companyId
  );
  const removalLoading = useSelector(
    (state) => state.singleList.removeSingleCompany.loading
  );

  const renderResponseButton = (id) => {
    if (
      responses &&
      responses.some(
        (r) => r.organizationNumber === id && r.response === "Maybe"
      )
    ) {
      return <InfoTableButton title="Svarte kanskje" color="yellow" />;
    } else if (
      responses &&
      responses.some((r) => r.organizationNumber === id && r.response === "No")
    ) {
      return <InfoTableButton title="Svarte nei" color="red" />;
    } else if (
      responses &&
      responses.some((r) => r.organizationNumber === id && r.response === "Yes")
    ) {
      return <InfoTableButton title="Svarte ja" color="green" />;
    } else if (
      responses &&
      responses.some(
        (r) => r.organizationNumber === id && r.response === "No answer"
      )
    ) {
      return <InfoTableButton title="Svarte ikke" color="purple" />;
    } else {
      return <InfoTableButton title="Ikke kontaktet" color="gray" />;
    }
  };

  const showTitle = (phrase) => {
    var oldTitle = phrase
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
    if (oldTitle.length > 20) {
      return oldTitle.substring(0, 30) + "..";
    } else {
      return oldTitle;
    }
  };

  const selectCompany = () => {
    dispatch(setDisplayIndex(displayIndex));
  };

  const clickDeleteCompany = (organizationNumber) => {
    dispatch(
      requestRemoveCompanyListing({
        companyId: selectedCompany,
        listId: listId,
        organizationNumber: organizationNumber,
      })
    );
  };

  return (
    <tr
      className={`single-company-listing ${
        singleCompany.organisasjonsnummer ===
        activeDisplay.general.organizationNumber
          ? "active"
          : ""
      }`}
    >
      <td onClick={() => selectCompany()}>
        {singleCompany.organisasjonsnummer ===
        activeDisplay.general.organizationNumber ? (
          <i class="fas fa-caret-right active-indicator"></i>
        ) : null}
        <span className="company-title">{showTitle(singleCompany.navn)}</span>
      </td>
      <td></td>
      <td>{renderResponseButton(singleCompany.organisasjonsnummer)}</td>
      <td>
        <button
          onClick={() => clickDeleteCompany(singleCompany.organisasjonsnummer)}
          className="delete-button"
        >
          {removalLoading &&
          activeRemoval === singleCompany.organisasjonsnummer ? (
            <i class="fas fa-circle-notch fa-spin"></i>
          ) : (
            <i class="fad fa-trash-alt"></i>
          )}
        </button>
      </td>
    </tr>
  );
};

export default withRouter(Index);
